/** @jsxImportSource @emotion/react */
import React from 'react'
import { css } from '@emotion/react'
import { formatDate } from '@btime/helpers'

import { filterRepliesByParentReference } from '../../bioqualynet/_helpers/pdfHelpers'
import { useChildrenServiceOrders } from '../_load/ChildrenServiceOrdersLoader'
import { getRepliesFromBlockQuestion } from '../../tembici/_helpers/pdfHelpers'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import Separator from '../../../../components/pdf/Separator'
import View from '../../../../components/pdf/View'
import Text from '../../../../components/pdf/Text'
import {
  convertHoursInMinutes,
  findReplyByFieldId,
  findReplyByQuestionId,
  formatMinutesInHours,
  getReplyValue
} from '../_helpers/pdfHelpers'
import moment from 'moment'
import ServiceTable from '../sections/ServiceTable'
import ServiceProvidedTable from '../sections/ServiceProvidedTable'
import HourTable from '../sections/HourTable'
import KilometerTable from '../sections/KilometerTable'
import GlobalTotalTable from '../sections/GlobalTotalTable'

const Content = () => {
  const parentServiceOrder = useServiceOrder()
  const childrenServiceOrder = useChildrenServiceOrders()

  const childrenServiceOrders = childrenServiceOrder.filter(so => so.checklist.id !== 4)

  const allServiceOrders = [parentServiceOrder, ...childrenServiceOrders]

  const pricePerHour = findReplyByFieldId(parentServiceOrder.place.fieldValues, 6)?.value
  const pricePerKm = findReplyByFieldId(parentServiceOrder.place.fieldValues, 8)?.value

  const servicesData = allServiceOrders.map(service => {
    const completedSODate = service.events.filter(event => event.status.id === 8)[0].eventDate
    const formattedCompletedDate = formatDate('DD/MM/YYYY', completedSODate)
    const formattedTeam = `${service.user.name} e ${getReplyValue(findReplyByQuestionId(service.replies, 10)).name}`
    const serviceProvided = getReplyValue(findReplyByQuestionId(service.replies, 14))
      .map(sv => (sv.name === 'Outro' ? getReplyValue(findReplyByQuestionId(service.replies, 16)) : sv.name))
      .join(', ')
    const serviceDescription = [
      getReplyValue(findReplyByQuestionId(service.replies, 15)),
      getReplyValue(findReplyByQuestionId(service.replies, 18)),
      getReplyValue(findReplyByQuestionId(service.replies, 21))
    ]
      .filter(n => n)
      .join(', ')

    const startTime = moment(service.startDate)
    const endTime = moment(service.endDate)
    const formattedStartTime = formatDate('HH:mm', startTime)
    const formattedEndTime = formatDate('HH:mm', endTime)
    const hoursBetweenStartAndEndTime = moment.duration(endTime.diff(startTime, 'minutes'), 'minutes').asMinutes()

    const totalOfHoursInMinutes = hoursBetweenStartAndEndTime <= 240 ? 240 : hoursBetweenStartAndEndTime

    const kilometer = findReplyByFieldId(service.fieldValues, 11)?.value
    const officeHour = findReplyByFieldId(service.fieldValues, 10)?.value

    return {
      date: formattedCompletedDate,
      team: formattedTeam,
      place: parentServiceOrder.place.name,
      kilometer,
      officeHour,
      serviceProvided,
      serviceDescription,
      startTime: formattedStartTime,
      endTime: formattedEndTime,
      startTime2: '',
      endTime2: '',
      totalOfHoursInMinutes
    }
  })

  const sumServiceHoursInMinutes = servicesData.reduce((total, service) => total + service.totalOfHoursInMinutes, 0)
  const sumOfficeHours = servicesData.reduce((total, service) => total + service.officeHour, 0)
  const officeHoursInMinutes = convertHoursInMinutes(sumOfficeHours)

  const servicesProvidedSO = childrenServiceOrder.filter(so => so.checklist.id === 4)
  const servicesProvidedSOReplies = servicesProvidedSO[0].replies

  const servicesProvidedBlock = () => {
    const blockReply = findReplyByQuestionId(servicesProvidedSOReplies, 24)
    const servicesProvided = filterRepliesByParentReference(servicesProvidedSOReplies, blockReply.question.reference)

    const servicesProvidedResult = {}
    servicesProvided.forEach(serviceProvided => {
      const blockIndex = serviceProvided.blockIndex
      let servicesProvidedData = servicesProvidedResult[blockIndex]
      if (!servicesProvidedData) {
        const blockReplies = getRepliesFromBlockQuestion(servicesProvided, blockIndex)
        servicesProvidedData = {
          service: getReplyValue(findReplyByQuestionId(blockReplies, 22)),
          price: getReplyValue(findReplyByQuestionId(blockReplies, 23))
        }
        servicesProvidedResult[blockIndex] = servicesProvidedData
      }
    })
    return Object.values(servicesProvidedResult)
  }

  const servicesProvidedData = servicesProvidedBlock()

  // servicesProvided
  const sumServicesProvidedPrices = servicesProvidedData.reduce((total, service) => total + service.price, 0)

  // hours
  const totalOfHours = formatMinutesInHours(officeHoursInMinutes + sumServiceHoursInMinutes)
  const total = ((officeHoursInMinutes + sumServiceHoursInMinutes) / 60) * pricePerHour

  // kilometers
  const sumKmDriven = servicesData.reduce((total, service) => total + service.kilometer, 0)
  const total4 = sumKmDriven * pricePerKm

  //global
  const globalTotal = sumServicesProvidedPrices + total + total4

  const style = css`
    &:nth-child(odd) {
      background-color: #dbdbdb;
    }
    &:nth-child(even) {
      background-color: #ededed;
    }
  `
  return (
    <View pageBreakAfter>
      <Text bold size={18} align="center">
        Medição de Topografia
      </Text>

      <Separator weight={2} />
      <ServiceTable style={style} services={servicesData} />
      <ServiceProvidedTable style={style} servicesProvided={servicesProvidedData} />
      <HourTable totalOfHours={totalOfHours} pricePerHour={pricePerHour} total={total} />
      <KilometerTable sumKmDriven={sumKmDriven} pricePerKm={pricePerKm} />
      <GlobalTotalTable globalTotal={globalTotal} />
    </View>
  )
}

export default Content
